import { select, take, race, delay, put, call } from 'redux-saga/effects';
import {
  getParamAMSSegments,
  SET_PARAM_AMS_SEGMENTS,
} from '@corefront/redux-aba';
import { isAMSEnabledSelector } from '../../reducers/app/configuration';
import { logger } from '../../../services/index';

export const AMS_SEGMENTS_TIMEOUT = 3000;

export const logAMSSegmentsError = () => {
  logger.error('AMS SEGMENTS TIMEOUT');
};

export function* getAMSSegments(timeout) {
  yield put(getParamAMSSegments());
  return yield race({
    segments: take(SET_PARAM_AMS_SEGMENTS),
    timeout: delay(timeout),
  });
}

/**
 * if useAMSSegments is turned on - making request for them to host and block
 * rendering until params hasn't been gotten
 */
export function* checkAMSSegments() {
  const isAMSEnabled = yield select(isAMSEnabledSelector);

  if (isAMSEnabled) {
    const { timeout: amsTimeout } = yield call(
      getAMSSegments,
      AMS_SEGMENTS_TIMEOUT
    );

    if (amsTimeout) {
      yield call(logAMSSegmentsError);
    }
  }
}
